// extracted by mini-css-extract-plugin
export default {"option":"O088CB6STophrJAf7C1v","text":"SiRTl2giU2TNyRNoQ92M"};